import { isLoggedIn } from './lib/auth.js';
import { overlayOpen } from './lib/pull-refresh.js';

const routes = new Map();
const DEFAULT_ROUTE = 'home';

export function register(name, render) {
  routes.set(name, { render });
}

export function go(name) {
  window.location.hash = `#/${name}`;
}

function renderCurrent() {
  const app = document.getElementById('app');
  if (!isLoggedIn()) {
    return routes.get('login').render(app);
  }
  const hash = window.location.hash.replace(/^#\//, '') || DEFAULT_ROUTE;
  const route = routes.get(hash) || routes.get(DEFAULT_ROUTE);
  route.render(app);
}

// Coming back to Grit (from the lock screen, MyFitnessPal, iHealth...) reloads the screen's
// numbers, because the phone shortcuts write to Grit while it sits in the background
// (Kenny 2026-10-25: quick taps landed but the open Food screen still showed the old total).
// Never mid-workout, under an open sheet, or while a field has typing in it.
let hiddenAt = 0;
function refreshOnReturn() {
  if (document.hidden) { hiddenAt = Date.now(); return; }
  if (!hiddenAt || Date.now() - hiddenAt < 2000) return;
  hiddenAt = 0;
  const hash = window.location.hash.replace(/^#\//, '') || DEFAULT_ROUTE;
  if (hash === 'logger' || overlayOpen()) return;
  const ae = document.activeElement;
  if (ae && ae.matches && ae.matches('input,textarea,select,[contenteditable]') && ae.value) return;
  renderCurrent();
}

export function start() {
  document.addEventListener('visibilitychange', refreshOnReturn);
  window.addEventListener('hashchange', renderCurrent);
  // Only a sign-in change in another tab redraws. Every read also saves a copy on the device, so
  // redrawing on any change made two open tabs set each other off (hundreds of redraws, 2026-11-02).
  window.addEventListener('storage', (e) => { if (e.key === null || e.key === 'grit-user' || e.key === 'grit-viewing') renderCurrent(); });
  renderCurrent();
}
